module.exports = __webpack_public_path__ + "img/traction-logo.d6af29b4.png";